import { onMounted, onUnmounted, reactive } from 'vue';
import { AppStore } from '@apparatix/stores/AppStore';
export const useCrossFrameMessaging = () => {
    const modalStates = reactive({ shouldOpenChangePassword: false });
    const handleNavigationRequests = (message) => {
        if (message?.type !== 'navigate')
            return;
        if (!message?.data?.parentPage)
            return;
        const parentPage = AppStore.navigationItems.find(item => item.label.toLowerCase() === message.data.parentPage.toLowerCase());
        if (!parentPage) {
            throw new Error(`Unable to find parent navigation item ${message.data.parentPage}`);
        }
        const childPage = message.data.childPage ?
            parentPage.children.find(child => child.label.toLowerCase() === message.data.childPage.toLowerCase())
            : null;
        AppStore.setActivePage(parentPage);
        if (childPage) {
            if (message.data.urlParameters && !message.data.appendToUrl) {
                let newUrl = childPage.url;
                const { urlParameters } = message.data;
                for (const key in urlParameters) {
                    if (Object.hasOwn(urlParameters, key)) {
                        newUrl = `${newUrl}${key}=${urlParameters[key]}&`;
                    }
                }
                childPage.url = newUrl;
            }
            if (message.data.appendToUrl && !message.data.urlParameters) {
                childPage.url = childPage.url + message.data.appendToUrl;
            }
            if (message.data.appendToUrl && message.data.urlParameters) {
                console.error('Only appendToUrl or urlParameters should be set, but got both');
            }
            AppStore.setActiveSubPage(childPage);
        }
        if (!childPage && message.data.childPage) {
            throw new Error(`Unable to find sub-page of ${message.data.parentPage}: ${message.data.childPage}`);
        }
    };
    const handleOpenModalRequests = (message) => {
        if (message.data.name === 'change-password') {
            modalStates.shouldOpenChangePassword = true;
            console.log('Got open change password message');
        }
    };
    const dispatchMessage = (e) => {
        console.log('Got message', e);
        const message = e.data;
        if (message.type === 'navigate') {
            handleNavigationRequests(message);
        }
        if (message.type === 'open-modal') {
            handleOpenModalRequests(message);
        }
    };
    onMounted(() => {
        window.addEventListener('message', dispatchMessage);
    });
    onUnmounted(() => {
        window.removeEventListener('message', dispatchMessage);
    });
    return { modalStates };
};
